import React from 'react';

import { CountrysideMain } from '../../components/countryside/Main/Main';
import { BackgroundProvider } from '../../components/countryside/BackgroundProvider';
import { CountrysideHeader } from '../../components/countryside/Header/Header';
import { FiltersPanel } from '../../components/countryside/FiltersPanel/FiltersPanel';
import { CountrysideFiltersTabsContainer } from '../countryside/CountrysideFiltersTabsContainer/CountrysideFiltersTabsContainer';
import { CountrysideFiltersContainer } from '../countryside/CountrysideFiltersContainer/CountrysideFiltersContainer';
import { CountrysideBrandBanner } from '../../components/countryside/CountrysideBrandBanner/CountrysideBrandBanner';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { CountrysideVillagesContainer } from '../countryside/VillagesContainer/VillagesContainer';
import { CountrysideReviewsContainer } from '../countryside/ReviewsContainer/ReviewsContainer';
import { CountrysideMagazineContainer } from '../countryside/CountrysideMagazineContainer/CountrysideMagazineContainer';
import { GeoSwitcherWrapperContainer } from '../GeoSwitcherContainer';

export const CountrysideHomeContainer = () => (
  <CountrysideMain>
    <GeoSwitcherWrapperContainer />
    <BackgroundProvider>
      <CountrysideHeader>
        <FiltersPanel>
          <CountrysideFiltersTabsContainer />
          <CountrysideFiltersContainer />
        </FiltersPanel>
        <CountrysideBrandBanner />
      </CountrysideHeader>
    </BackgroundProvider>
    <RecommendationsContainer />
    <CountrysideVillagesContainer />
    <CountrysideReviewsContainer />
    <CountrysideMagazineContainer />
  </CountrysideMain>
);
